// extracted by mini-css-extract-plugin
module.exports = {"container":"EmailForm_container__uXk6w"};